import { h } from '../../../../../shared/utils/tsxToDom';
import styles from './index.module.css';

const formatDisplayDate = (dateStr: string) => {
  try {
    const dateObj = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
    };
    const formatter = new Intl.DateTimeFormat('ja-JP-u-ca-gregory', options);
    const convertedDateStr = formatter.format(dateObj).replace(/(\d+)\/(\d+)\/(\d+)\((.*)\)/, '$1年$2月$3日($4)');
    return convertedDateStr;
  } catch (e) {
    return dateStr;
  }
};

export const CalendarDatePickerOpener = ({
  id,
  ariaControls,
  ariaDescribedBy,
  disabled,
  selectedDate,
  onClick,
}: {
  id?: string;
  ariaControls?: string;
  ariaDescribedBy?: string;
  disabled?: boolean;
  selectedDate: string;
  onClick?: (event: Event) => void;
}) => {
  return (
    <button
      type="button"
      id={id}
      aria-controls={ariaControls}
      class={styles.CalendarDatePickerOpener}
      aria-describedby={ariaDescribedBy}
      onClick={onClick}
      disabled={disabled || selectedDate === ''}
    >
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5 0H2.5C1.96957 0 1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2L0.5 14C0.5 14.5304 0.710714 15.0391 1.08579 15.4142C1.46086 15.7893 1.96957 16 2.5 16H14.5C15.0304 16 15.5391 15.7893 15.9142 15.4142C16.2893 15.0391 16.5 14.5304 16.5 14V2C16.5 1.46957 16.2893 0.960859 15.9142 0.585786C15.5391 0.210714 15.0304 0 14.5 0V0ZM1.5 3.857C1.5 3.384 1.948 3 2.5 3H14.5C15.052 3 15.5 3.384 15.5 3.857V14.143C15.5 14.616 15.052 15 14.5 15H2.5C1.948 15 1.5 14.616 1.5 14.143V3.857Z"
          fill="currentColor"
        />
        <path
          d="M7 7C7.26522 7 7.51957 6.89464 7.70711 6.70711C7.89464 6.51957 8 6.26522 8 6C8 5.73478 7.89464 5.48043 7.70711 5.29289C7.51957 5.10536 7.26522 5 7 5C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6C6 6.26522 6.10536 6.51957 6.29289 6.70711C6.48043 6.89464 6.73478 7 7 7ZM10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7ZM13 7C13.2652 7 13.5196 6.89464 13.7071 6.70711C13.8946 6.51957 14 6.26522 14 6C14 5.73478 13.8946 5.48043 13.7071 5.29289C13.5196 5.10536 13.2652 5 13 5C12.7348 5 12.4804 5.10536 12.2929 5.29289C12.1054 5.48043 12 5.73478 12 6C12 6.26522 12.1054 6.51957 12.2929 6.70711C12.4804 6.89464 12.7348 7 13 7ZM4 10C4.26522 10 4.51957 9.89464 4.70711 9.70711C4.89464 9.51957 5 9.26522 5 9C5 8.73478 4.89464 8.48043 4.70711 8.29289C4.51957 8.10536 4.26522 8 4 8C3.73478 8 3.48043 8.10536 3.29289 8.29289C3.10536 8.48043 3 8.73478 3 9C3 9.26522 3.10536 9.51957 3.29289 9.70711C3.48043 9.89464 3.73478 10 4 10ZM7 10C7.26522 10 7.51957 9.89464 7.70711 9.70711C7.89464 9.51957 8 9.26522 8 9C8 8.73478 7.89464 8.48043 7.70711 8.29289C7.51957 8.10536 7.26522 8 7 8C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9C6 9.26522 6.10536 9.51957 6.29289 9.70711C6.48043 9.89464 6.73478 10 7 10ZM10 10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8C9.73478 8 9.48043 8.10536 9.29289 8.29289C9.10536 8.48043 9 8.73478 9 9C9 9.26522 9.10536 9.51957 9.29289 9.70711C9.48043 9.89464 9.73478 10 10 10ZM13 10C13.2652 10 13.5196 9.89464 13.7071 9.70711C13.8946 9.51957 14 9.26522 14 9C14 8.73478 13.8946 8.48043 13.7071 8.29289C13.5196 8.10536 13.2652 8 13 8C12.7348 8 12.4804 8.10536 12.2929 8.29289C12.1054 8.48043 12 8.73478 12 9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10ZM4 13C4.26522 13 4.51957 12.8946 4.70711 12.7071C4.89464 12.5196 5 12.2652 5 12C5 11.7348 4.89464 11.4804 4.70711 11.2929C4.51957 11.1054 4.26522 11 4 11C3.73478 11 3.48043 11.1054 3.29289 11.2929C3.10536 11.4804 3 11.7348 3 12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13ZM7 13C7.26522 13 7.51957 12.8946 7.70711 12.7071C7.89464 12.5196 8 12.2652 8 12C8 11.7348 7.89464 11.4804 7.70711 11.2929C7.51957 11.1054 7.26522 11 7 11C6.73478 11 6.48043 11.1054 6.29289 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.29289 12.7071C6.48043 12.8946 6.73478 13 7 13ZM10 13C10.2652 13 10.5196 12.8946 10.7071 12.7071C10.8946 12.5196 11 12.2652 11 12C11 11.7348 10.8946 11.4804 10.7071 11.2929C10.5196 11.1054 10.2652 11 10 11C9.73478 11 9.48043 11.1054 9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071C9.48043 12.8946 9.73478 13 10 13Z"
          fill="currentColor"
        />
      </svg>
      {/* <span>2023年9月16日(土)</span> */}
      <span>{selectedDate === '' ? '選択できません' : formatDisplayDate(selectedDate)}</span>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3.00002L8.48809 2.43057L8 2.01221L7.51191 2.43057L8 3.00002ZM8 12L7.51191 12.5695L8 12.9878L8.48809 12.5695L8 12ZM4.98809 6.56946L8.48809 3.56946L7.51191 2.43057L4.0119 5.43058L4.98809 6.56946ZM7.51191 3.56946L11.0119 6.56946L11.9881 5.43058L8.48809 2.43057L7.51191 3.56946ZM4.0119 9.56946L7.51191 12.5695L8.48809 11.4306L4.98809 8.43058L4.0119 9.56946ZM8.48809 12.5695L11.9881 9.56946L11.0119 8.43058L7.51191 11.4306L8.48809 12.5695Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};
